export default __webpack_public_path__ + "static/Symbol_1-f490c19a6131aa3946fe9da4c53ee69f.png";